require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-threepointone-bs-nice.json") })
        }
      }, "path---package-unpublished-threepointone-bs-nice");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-threepointone-bs-nice!./.cache/json/package-unpublished-threepointone-bs-nice.json
// module id = 969
// module chunks = 231608221292675